import _PullDownRefresh from './PullDownRefresh';
import './style';

export type { PullDownRefreshProps } from './PullDownRefresh';
export * from './type';

export const PullDownRefresh = _PullDownRefresh;
export default PullDownRefresh;
